const hideZendeskHelp = () => () => {
  window.zE.hide();
};

export default hideZendeskHelp;
